import { render, staticRenderFns } from "./TransfertDossiers.vue?vue&type=template&id=857d68d8&"
import script from "./TransfertDossiers.vue?vue&type=script&lang=ts&"
export * from "./TransfertDossiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports